module.exports = __webpack_public_path__ + "img/chevron-up-regular.af64f8cf.svg";